var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var cio_datamodel = require("cio-datamodel");

var PathSegmentView = function (gui, interactionModel, parentGroup, layers, config, parent) {
    var self = this;

    this.gui = gui;
    this.interactionModel = interactionModel;
    this.object = this.interactionModel.object;
    this.layers = layers;
    this.parent = parent;

    this.cameraModel = this.gui.editorModel.cameraModel();

    this.initGroups(parentGroup, [layers.control]);

    this.controlGroup = this.getGroupInfo(layers.control).svgGroup;

    // TODO test this
    //if (this.gui.mode == lib_core.GuiMode.EDIT) {
        $(this.controlGroup).mousedown(function(event){
            self.gui.stateMachine.handle(self.getMouseDownEvent(event));
        });
    //}

    this.prev_object = this.object.previous();
    this.prev_object.onBubble(self, function(){
        self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
    },10);
    this.object.onBubble(self, function(){
        self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
    },10);

    this.cameraModel.viewS.onChange(self, function(){
        if(self.object.isAlive())
            self.gui.heavyHandler.scheduleHeavy('resize_control', self.resizeControl, self, [], self);
    },10);

    this.draw();
};

lib_core.mixin(PathSegmentView, editor_2d.DrawingElement);

module.exports = PathSegmentView;

PathSegmentView.prototype.draw = function () {
    var self = this;

    var prev_handle = this.interactionModel.prev_handle;
    var object = this.object;

    if(!this.object.isAlive()) return;

    var path = this.gui.svg.createPath();
    path.move(prev_handle.coord().getX(), prev_handle.coord().getY());

    if (object.type() == cio_datamodel.PathType.LINE ||
        (object.type() == cio_datamodel.PathType.POINT && object.parent().closed())) {
        path.line(object.getEndpoint().getX(), object.getEndpoint().getY());
    } else if (object.type() == cio_datamodel.PathType.CURVEC) {
        path.curveC(object.tan_0().getX(), object.tan_0().getY(), object.tan_1().getX(), object.tan_1().getY(), object.getEndpoint().getX(), object.getEndpoint().getY());
    } else if (object.type() == cio_datamodel.PathType.ARC) {
        path.arc(object.xRadius(), object.yRadius(),
            object.angle(),
            (object.largeArcFlag() ? 1 : 0),
            (object.sweepFlag() ? 1 : 0),
            object.endpoint().getX(), object.endpoint().getY(),
            false);
    }

    // draw control
    $(this.controlGroup).empty();
    this.gui.svg.path(this.controlGroup, path, {
        'fill': 'none'
    });
    this.control = $(":nth-last-child(1)", this.controlGroup);
    this.resizeControl();
};

PathSegmentView.prototype.resizeControl = function () {
    var strokeWidth = this.object.parent().strokeWidth();
    var width = strokeWidth + 4 / this.cameraModel.viewS();
    if(this.control) this.control.attr("stroke-width", width);
};

PathSegmentView.prototype.getMouseDownEvent = function (event) {
    var cEvent = this.parent.getMouseDownEvent(event);
    cEvent.element('subelement', this.interactionModel);
    return cEvent;
};
